import { S, ui, save } from "../../app/store.js";
import { can } from "../../services/access.js";
import { today } from "../../domain/dates.js";
import { mkRun } from "../../domain/payroll.js";
import { log } from "../../services/audit.js";
import { render } from "../../app/shell.js";
import { finishCreation } from "../../components/creation-flow.js";
import { esc } from "../../domain/format.js";
export function cutoffForm() {
  if (!can("pay.prepare")) return "";
  return `<details class="panel"><summary>Create payroll cutoff</summary><form id="cutoff-form" class="work-log-form"><div class="form"><label>Cutoff starts<input name="from" id="cutoff-from" type="date" required></label><label>Cutoff ends<input name="to" id="cutoff-to" type="date" required></label><label>Pay date<input name="pay" id="cutoff-pay" type="date" required></label></div>${ui.cutoffError ? `<p class="err">${esc(ui.cutoffError)}</p>` : ""}<button type="submit" class="pri">Prepare payroll</button></form></details>`;
}
export function installCutoffEvents() {
  document.addEventListener("submit", (event) => {
    if (event.target.id !== "cutoff-form") return;
    event.preventDefault();
    if (!can("pay.prepare")) return;
    const { from, to, pay } = Object.fromEntries(new FormData(event.target));
    let error = "";
    if (
      !from ||
      !to ||
      !pay ||
      to < from ||
      from.slice(0, 7) !== to.slice(0, 7) ||
      !["01", "16"].includes(from.slice(-2))
    )
      error = "Choose a semi-monthly cutoff within one calendar month.";
    else if (S.runs.some((r) => from <= r.to && to >= r.from))
      error = "This cutoff overlaps an existing payroll run.";
    if (error) {
      ui.cutoffError = error;
      render();
      return;
    }
    const run = mkRun(S, from, to, pay, ui.user);
    log("Prepared payroll", run.id);
    ui.cutoffError = "";
    save();
    finishCreation();
    render();
  });
}
